export class PostprocessingProductVisitor {
    constructor(transformer) {
        this.transformer = transformer;
    }
    visitCompatibilityTable(doc) {
    }
    visitExternalFiled(doc) {
    }
    visitJsFilter(doc) {
    }
    visitOclConstraint(doc) {
    }
    visitOclFilter(doc) {
    }
    visitOption(doc) {
    }
    visitOptionGroup(doc) {
    }
    visitProduct(doc) {
        this.transformer.postProcessProduct(doc);
    }
    visitProductGroup(doc) {
    }
    visitUnknown(doc) {
    }
}
//# sourceMappingURL=PostprocessingProductVisitor.js.map